import React from 'react';
import { ArticleList } from '@components/common/ArticleList';
import { SectionTitle } from '@modules/Dashboard/Home/components/SectionTitle';
import { membershipsStrategiesArticle, perksGuideArticle } from '../../../../consts';
export const Articles = () => (React.createElement("div", { style: { marginTop: 48 } },
    React.createElement(SectionTitle, { title: "Need some ideas? Check out these helpful resources" }),
    React.createElement(ArticleList, { items: [membershipsStrategiesArticle, perksGuideArticle] })));
